import { Fragment } from "react";

import { isPresent } from "neetocist";

import SubLink from "./SubLink";

import { filterByPermissions } from "../../utils";

const Items = ({ items, isSettingsItems = false, isCountsLoading }) => (
  <div
    className="neeto-molecules-sidebar__sublink-wrapper"
    data-testid="sidebar-sub-link-wrapper"
  >
    {items.filter(filterByPermissions).map((subItem, subIndex) => (
      <Fragment key={subIndex}>
        <SubLink
          {...{ ...subItem, isCountsLoading }}
          href={subItem.href}
          isActive={subItem.isActive}
          isSectionHeader={isPresent(subItem.item)}
          to={subItem.to ?? subItem.path}
          onClick={subItem.onClick}
        />
        {isSettingsItems && isPresent(subItem.items) && (
          <>
            <Items {...{ isSettingsItems }} items={subItem.items} />
            {items.length - 1 !== subIndex && (
              <hr className="neeto-molecules-sidebar__separator neeto-ui-border-gray-200" />
            )}
          </>
        )}
      </Fragment>
    ))}
  </div>
);

export default Items;
